"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.addSeparatorToCardDate = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _dateFns = require("date-fns");
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
var _formik = require("formik");
var _utilities = _interopRequireDefault(require("../../utilities"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Text = _interopRequireDefault(require("../Text"));
var _Label = _interopRequireDefault(require("../Label"));
var _RadioButton = _interopRequireDefault(require("../RadioButton"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _CreditCardForm = require("../CreditCardForm");
var _GuestPersonalInfo = require("../GuestPersonalInfo");
var _constants = require("./constants");
var _BigPaySavedCardItem = _interopRequireDefault(require("./BigPaySavedCardItem.proptypes"));
var _constant = require("../constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CardItemContainer = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__CardItemContainer",
  componentId: "sc-r7ita2-0"
})(["display:flex;flex-direction:column;justify-content:space-between;background-repeat:no-repeat;background-size:100% 100%;box-sizing:border-box;cursor:pointer;width:", ";height:", ";max-height:", ";padding:20px;background-image:", "};"], function (_ref) {
  var cardWidth = _ref.cardWidth;
  return !cardWidth ? _constants.SAVED_CARD_WIDTH : cardWidth;
}, function (_ref2) {
  var cardHeight = _ref2.cardHeight;
  return !cardHeight ? _constants.SAVED_CARD_HEIGHT : cardHeight;
}, _constants.SAVED_CARD_HEIGHT, function (_ref3) {
  var cardBrand = _ref3.cardBrand,
    cardTypeImages = _ref3.cardTypeImages,
    cardTypeDefaultImage = _ref3.cardTypeDefaultImage;
  return "url(".concat(cardTypeImages[cardBrand] || cardTypeDefaultImage, ")");
});
CardItemContainer.displayName = 'CardItemContainer';
var DefaultTagContainer = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__DefaultTagContainer",
  componentId: "sc-r7ita2-1"
})(["display:flex;min-height:20px;justify-content:flex-end;"]);
var DefaultTag = _styledComponents.default.span.withConfig({
  displayName: "BigPaySavedCardItem__DefaultTag",
  componentId: "sc-r7ita2-2"
})(["padding:1px 4px;background-color:", ";border-radius:4px;"], function (_ref4) {
  var isSecondaryColor = _ref4.isSecondaryColor,
    theme = _ref4.theme;
  return isSecondaryColor ? theme.backgroundColor.secondaryLight : 'rgba(248, 248, 248, 0.3)';
});
DefaultTag.displayName = 'DefaultTag';
var MaskedCreditCardContainer = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__MaskedCreditCardContainer",
  componentId: "sc-r7ita2-3"
})(["display:flex;justify-content:space-between;"]);
MaskedCreditCardContainer.displayName = 'MaskedCreditCardContainer';
var MaskedCardItem = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__MaskedCardItem",
  componentId: "sc-r7ita2-4"
})(["display:flex;align-items:center;"]);
var StyledIconContainer = _styledComponents.default.span.withConfig({
  displayName: "BigPaySavedCardItem__StyledIconContainer",
  componentId: "sc-r7ita2-5"
})(["padding:0 2px;display:flex;"]);
var RadioButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__RadioButtonContainer",
  componentId: "sc-r7ita2-6"
})(["display:flex;justify-content:space-between;cursor:pointer;"]);
RadioButtonContainer.displayName = 'RadioButtonContainer';
var RadioLabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__RadioLabelWrapper",
  componentId: "sc-r7ita2-7"
})(["display:flex;align-items:center;width:100%;margin-left:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.XXXSmall;
});
var BankLogoContainer = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__BankLogoContainer",
  componentId: "sc-r7ita2-8"
})(["display:flex;align-content:center;align-items:center;margin-right:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.xxtiny;
});
var DotContainer = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__DotContainer",
  componentId: "sc-r7ita2-9"
})(["display:flex;margin-right:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.xxtiny;
});
var AdditionalInfoContainer = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__AdditionalInfoContainer",
  componentId: "sc-r7ita2-10"
})(["display:flex;justify-content:space-between;margin-left:", ";padding:5px 0 10px 0;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.semiLarge;
});
var StyledSwitchWrapper = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__StyledSwitchWrapper",
  componentId: "sc-r7ita2-11"
})(["margin-top:5px;display:flex;align-items:center;.MuiSwitch-root{width:44px;height:21px;padding:4px;margin-right:", ";}.MuiButtonBase-root{padding:0px;}.MuiSwitch-thumb{color:", ";border:1px solid ", ";height:18px;width:18px;}.MuiSwitch-track{background-color:", ";}.Mui-checked{.MuiSwitch-thumb{color:", ";}&.MuiSwitch-colorSecondary{color:", ";& + .MuiSwitch-track{background-color:", ";}}&:hover.MuiSwitch-colorSecondary{background-color:rgba(75,79,166,0.04);}}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.tiny;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.default;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.secondary;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.greyDark;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.secondary;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.secondary;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.secondary;
});
StyledSwitchWrapper.displayName = 'StyledSwitchWrapper';
var BankImage = _styledComponents.default.img.withConfig({
  displayName: "BigPaySavedCardItem__BankImage",
  componentId: "sc-r7ita2-12"
})(["width:", ";margin-right:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.space.semiLarge;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.space.xxtiny;
});
var ExpiryDateContainer = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__ExpiryDateContainer",
  componentId: "sc-r7ita2-13"
})(["cursor:pointer;"]);
var CvvContainer = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__CvvContainer",
  componentId: "sc-r7ita2-14"
})(["width:150px;display:flex;margin-top:", ";align-content:center;align-items:center;"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.space.xxtiny;
});
CvvContainer.displayName = 'CvvContainer';
var InformationIconContainer = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__InformationIconContainer",
  componentId: "sc-r7ita2-15"
})(["margin:0 10px;cursor:pointer;"]);
var StyledModal = (0, _styledComponents.default)(_Modal.default).withConfig({
  displayName: "BigPaySavedCardItem__StyledModal",
  componentId: "sc-r7ita2-16"
})(["#modal-header-title{font-size:", ";}"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontSize.semiXSmall;
});
var FourDotIcons = function FourDotIcons(isSmallMobile, neutralColor) {
  var fontsize = isSmallMobile ? 'XXSmall' : 'semiXSmall';
  var color = neutralColor ? 'neutral' : 'default';
  return /*#__PURE__*/_react.default.createElement(MaskedCardItem, null, /*#__PURE__*/_react.default.createElement(StyledIconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: color,
    fontsize: fontsize,
    icon: "DotIcon"
  })), /*#__PURE__*/_react.default.createElement(StyledIconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: color,
    fontsize: fontsize,
    icon: "DotIcon"
  })), /*#__PURE__*/_react.default.createElement(StyledIconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: color,
    fontsize: fontsize,
    icon: "DotIcon"
  })), /*#__PURE__*/_react.default.createElement(StyledIconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: color,
    fontsize: fontsize,
    icon: "DotIcon"
  })));
};
var CardInfoContainer = _styledComponents.default.div.withConfig({
  displayName: "BigPaySavedCardItem__CardInfoContainer",
  componentId: "sc-r7ita2-17"
})(["display:grid;grid-template-columns:75% 25%;"]);
CardInfoContainer.displayName = 'CardInfoContainer';
var getLastFourDigits = function getLastFourDigits(creditCardNumber) {
  return !creditCardNumber || creditCardNumber.length <= 4 ? '' : creditCardNumber.substr(creditCardNumber.length - 4);
};
var addSeparatorToCardDate = function addSeparatorToCardDate(dateString) {
  var date = (0, _dateFns.parse)(dateString, _constants.INTIAL_EXPIRY_DATE_FORMAT, Date.now());
  return (0, _dateFns.isValid)(date) ? (0, _dateFns.format)(date, _constants.EXPIRY_DATE_FORMAT) : dateString;
};
exports.addSeparatorToCardDate = addSeparatorToCardDate;
var BigPaySavedCardItem = function BigPaySavedCardItem(_ref20) {
  var accessible = _ref20.accessible,
    theme = _ref20.theme,
    data = _ref20.data,
    translation = _ref20.translation,
    onClick = _ref20.onClick,
    cardWidth = _ref20.cardWidth,
    cardTypeImages = _ref20.cardTypeImages,
    cardTypeDefaultImage = _ref20.cardTypeDefaultImage,
    isPaymentPage = _ref20.isPaymentPage,
    isSelected = _ref20.isSelected,
    isEnableCvv = _ref20.isEnableCvv,
    handleField = _ref20.handleField,
    formRef = _ref20.formRef,
    onSavedCardToggle = _ref20.onSavedCardToggle,
    cardLogoSource = _ref20.cardLogoSource;
  var cardHolder = translation.cardHolder,
    expires = translation.expires,
    defaultTag = translation.defaultTag,
    cvvLabel = translation.cvvLabel,
    expiryDateLabel = translation.expiryDateLabel,
    defaultCardLabel = translation.defaultCardLabel,
    modalTitle = translation.modalTitle,
    modalDescription = translation.modalDescription,
    processingFeeLabel = translation.processingFeeLabel;
  var CardType = data.CardType,
    CreditCard = data.CreditCard,
    PreferredCard = data.PreferredCard,
    ExpiryDate = data.ExpiryDate,
    AccountHolder = data.AccountHolder,
    DefaultCard = data.DefaultCard,
    ProcessingFee = data.ProcessingFee;
  var tabIndex = !accessible ? '-1' : '0';
  var cardLogo = _objectSpread(_objectSpread({}, _constants.CARD_LOGO), cardLogoSource);
  var containerRef = _react.default.useRef(null);
  var _useState = (0, _react.useState)(cardWidth || _constants.SAVED_CARD_WIDTH),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    cardHeight = _useState2[0],
    setCardHeight = _useState2[1];
  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 300;
  };
  var _useState3 = (0, _react.useState)(innerWidth()),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    windowWidth = _useState4[0],
    setWindowWidth = _useState4[1];
  var _useState5 = (0, _react.useState)(DefaultCard),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isDefaultCard = _useState6[0],
    setIsDefaultCard = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    openModal = _useState8[0],
    setOpenModal = _useState8[1];
  var isSmallMobile = windowWidth <= parseInt(_constant.BREAKPOINTS.SMALL_MOBILE.replace('px', ''), 10);
  var setContainerWidth = (0, _react.useCallback)(function () {
    setWindowWidth(innerWidth());
    if (containerRef.current) {
      var containerWidth = containerRef.current.getBoundingClientRect().width;
      setCardHeight("".concat(containerWidth / 1.56, "px"));
    }
  }, []);
  (0, _react.useEffect)(function () {
    setContainerWidth();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', setContainerWidth);
    }
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', setContainerWidth);
      }
    };
  }, [setContainerWidth]);
  var clickHander = function clickHander() {
    onClick(_objectSpread({}, data));
  };
  var toggleHandler = function toggleHandler() {
    setIsDefaultCard(function (prevState) {
      onSavedCardToggle(!prevState);
      return !prevState;
    });
  };
  var closeModalHandler = function closeModalHandler() {
    setOpenModal(!openModal);
  };
  var getFormatedProcessingFeeAmount = function getFormatedProcessingFeeAmount() {
    return _utilities.default.formatAmount(ProcessingFee.amount, 2, ProcessingFee.currency);
  };
  (0, _react.useEffect)(function () {
    if (data === undefined) return;
    setIsDefaultCard(data.DefaultCard);
  }, [data]);
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, !isPaymentPage ? /*#__PURE__*/_react.default.createElement(CardItemContainer, {
    tabIndex: tabIndex,
    cardWidth: cardWidth,
    cardBrand: CardType,
    onClick: clickHander,
    cardHeight: cardHeight,
    ref: containerRef,
    cardTypeImages: cardTypeImages,
    cardTypeDefaultImage: cardTypeDefaultImage
  }, /*#__PURE__*/_react.default.createElement(DefaultTagContainer, null, PreferredCard && /*#__PURE__*/_react.default.createElement(DefaultTag, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "small",
    color: "default",
    theme: theme,
    accessible: accessible
  }, defaultTag))), /*#__PURE__*/_react.default.createElement(MaskedCreditCardContainer, null, FourDotIcons(isSmallMobile), FourDotIcons(isSmallMobile), FourDotIcons(isSmallMobile), /*#__PURE__*/_react.default.createElement(MaskedCardItem, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    theme: theme,
    color: "default",
    type: isSmallMobile ? 'medium' : 'titleNormal'
  }, getLastFourDigits(CreditCard)))), /*#__PURE__*/_react.default.createElement(CardInfoContainer, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    display: "block",
    type: "small",
    color: "default",
    theme: theme,
    accessible: accessible
  }, cardHolder), /*#__PURE__*/_react.default.createElement(_Text.default, {
    display: "block",
    textLimit: 20,
    color: "default",
    theme: theme,
    accessible: accessible
  }, AccountHolder)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    display: "block",
    type: "small",
    color: "default",
    textAlign: "right",
    theme: theme,
    accessible: accessible
  }, expires), /*#__PURE__*/_react.default.createElement(_Text.default, {
    display: "block",
    color: "default",
    textAlign: "right",
    theme: theme,
    accessible: accessible
  }, addSeparatorToCardDate(ExpiryDate))))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledModal, {
    openModal: openModal,
    width: "400px",
    onClose: closeModalHandler,
    accessible: accessible,
    title: modalTitle,
    showHeaderBorder: false,
    modalCenter: true,
    customProperties: {
      minHeight: '150px'
    }
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    display: "block",
    theme: theme,
    type: "sub",
    accessible: accessible,
    color: "greyDarker"
  }, modalDescription)), /*#__PURE__*/_react.default.createElement(RadioButtonContainer, {
    onClick: clickHander
  }, /*#__PURE__*/_react.default.createElement(_RadioButton.default, {
    accessible: accessible,
    boldText: false,
    color: "secondary",
    selected: isSelected,
    textColor: "neutral",
    theme: theme,
    borderColor: "greyDark"
  }), /*#__PURE__*/_react.default.createElement(RadioLabelWrapper, null, /*#__PURE__*/_react.default.createElement(BankLogoContainer, null, /*#__PURE__*/_react.default.createElement(BankImage, {
    src: cardLogo[CardType],
    alt: "BankImage"
  })), /*#__PURE__*/_react.default.createElement(DotContainer, null, FourDotIcons(true, true)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    display: "block",
    theme: theme,
    color: "neutral",
    type: "medium"
  }, getLastFourDigits(CreditCard)))), /*#__PURE__*/_react.default.createElement(DefaultTagContainer, null, PreferredCard && /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: "AIRASIA_CLASSIC"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    accessible: accessible,
    labelColor: "secondaryLight",
    textColor: "secondaryDark"
  }, defaultTag)))), /*#__PURE__*/_react.default.createElement(AdditionalInfoContainer, {
    showBorderBottom: true
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(ExpiryDateContainer, {
    onClick: clickHander
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    display: "block",
    theme: theme,
    type: "sub",
    accessible: accessible,
    color: "greyDark"
  }, expiryDateLabel, " ", addSeparatorToCardDate(ExpiryDate))), isSelected && !PreferredCard && /*#__PURE__*/_react.default.createElement(StyledSwitchWrapper, null, /*#__PURE__*/_react.default.createElement(_Switch.default, {
    checked: isDefaultCard,
    onChange: toggleHandler
  }), /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "textSmall",
    theme: theme,
    accessible: accessible
  }, defaultCardLabel), /*#__PURE__*/_react.default.createElement(InformationIconContainer, {
    onClick: function onClick() {
      setOpenModal(!openModal);
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: "secondary",
    fontsize: "normal",
    icon: "InfoOutlinedIcon"
  }))), ProcessingFee && /*#__PURE__*/_react.default.createElement(_Text.default, {
    display: "block",
    theme: theme,
    type: "sub",
    accessible: accessible,
    color: "greyDarker"
  }, "".concat(processingFeeLabel, ": ").concat(ProcessingFee.currency, " ").concat(getFormatedProcessingFeeAmount()))), isSelected && isEnableCvv && /*#__PURE__*/_react.default.createElement(CvvContainer, null, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    innerRef: formRef,
    initialValues: _constants.INITIAL_VALUES,
    enableReinitialize: true
  }, function (props) {
    return /*#__PURE__*/_react.default.createElement(_formik.Field, {
      component: _CreditCardForm.renderField,
      customProperties: {
        maxlength: 3
      },
      type: "number",
      accessible: accessible,
      alwaysShowLabel: false,
      label: cvvLabel || _constants.FIELDS.cvv.label,
      name: _constants.FIELDS.cvv.name,
      theme: theme,
      handleField: handleField,
      value: props.values[_constants.FIELDS.cvv.name],
      showIcon: true,
      icon: "CvvIcon",
      validate: function validate(val) {
        return (0, _GuestPersonalInfo.validators)(val, cvvLabel || _constants.FIELDS.cvv.label, translation, [_CreditCardForm.validate.required]);
      }
    });
  })))));
};
BigPaySavedCardItem.propTypes = _BigPaySavedCardItem.default.PropTypes;
BigPaySavedCardItem.defaultProps = _BigPaySavedCardItem.default.DefaultProps;
var _default = BigPaySavedCardItem;
exports.default = _default;